import { useContext, useEffect } from 'react'

import ModalContext from 'contexts/ModalContext'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { SET_SHOW_LUX_PLUS_FREE_PREVIEW_MODAL } from 'actions/actionConstants'
import LuxPlusFreePreviewUnlockedModal from 'luxPlus/components/modals/LuxPlusFreePreviewUnlockedModal'

/**
 * Opens the "you've unlocked a free preview" celebration modal once a customer has been enrolled
 * into the LuxPlus+ Free Preview (createFreePreviewMember sets the one-shot flag). The flag is
 * cleared immediately so the modal only shows once. Replaces the old success snackbar.
 *
 * The trigger is read before clearing and passed down rather than selected inside the modal —
 * clearing the flag wipes it from the store on the same tick the modal mounts.
 */
function useShowLuxPlusFreePreviewUnlockedModal() {
  const showModal = useContext(ModalContext)
  const dispatch = useAppDispatch()
  const shouldShow = useAppSelector(state => state.luxPlus.showFreePreviewEnrolledModal ?? false)
  const trigger = useAppSelector(state => state.luxPlus.freePreviewEnrolledTrigger)

  useEffect(() => {
    if (!shouldShow) return
    dispatch({ type: SET_SHOW_LUX_PLUS_FREE_PREVIEW_MODAL, show: false })
    showModal(<LuxPlusFreePreviewUnlockedModal trigger={trigger} />)
  }, [shouldShow, trigger, dispatch, showModal])
}

export default useShowLuxPlusFreePreviewUnlockedModal
